import { combineReducers } from 'redux';

import { entities } from './entities';
import { errors } from './errors/errors';
import { geolocation } from './geolocation/geolocation';
import { isFetching } from './isFetching/isFetching';
import { publicKey } from './publicKey/publicKey';
import { ui } from './ui';

const rootReducer = combineReducers({
  entities,
  errors,
  geolocation,
  isFetching,
  publicKey,
  ui,
});

export { rootReducer };
